// eslint-disable-next-line import/prefer-default-export
export const SEARCH_INPUT_DELAY: number = 400;
